function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPc04 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.49185,62.87851l.27991-.55982c1.15145-2.60825,2.60825-3.14262,3.68971-3.08536a1.11379,1.11379,0,0,1,.967,1.514,10.48869,10.48869,0,0,0-.61707,3.308c3.08536,1.32957,3.04719,5.15287,3.04719,5.15287l.827.31172a12.26993,12.26993,0,0,0,4.99383.76339l5.82084-.84609",
    style: {
      fill: "none",
      stroke: "#ed6f5f",
      strokeMiterlimit: 10,
      strokeWidth: "1.272314779578551px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.86063,72.16641l-.07634.15267s2.29652,3.28258,9.4024,2.97722c0,0,4.9175,5.4137,14.31354,4.84752",
    style: {
      fill: "none",
      stroke: "#ed6f5f",
      strokeMiterlimit: 10,
      strokeWidth: "1.272314779578551px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0469,64.642s-3.0977-3.36752-5.20046-1.29383a8.84473,8.84473,0,0,0-2.815,7.44915c.39689,2.59265,4.45678,2.01364,4.93528,1.39686s-.65342-2.42118-.65342-2.42118,2.21787,1.04136,2.67044.21921-.8249-2.6777-.8249-2.6777,1.90084.73365,2.55013-.18288S22.0469,64.642,22.0469,64.642Z",
    style: {
      fill: "none",
      stroke: "#ed6f5f",
      strokeMiterlimit: 10,
      strokeWidth: "1.272314779578551px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.74809,68.80113a.33766.33766,0,0,1,.07634.06362s.5789.81428,1.48861,1.97209c1.7876,2.29016,4.84751,5.93535,7.2013,7.34761,3.54339,2.13113,11.031,8.45454,11.031,13.42293L69.004,91.42925l-24.655-.31551C33.687,79.80923,37.78774,70.8432,39.70257,67.99321",
    style: {
      fill: "none",
      stroke: "#ffafa1",
      strokeLinejoin: "round",
      strokeWidth: "1.272314779578551px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0569,32.66106l-.47387-.00317c.17772-.00419.81392-.00318,1.00268-.00318l.27026.00318c-.19335.00162-.60907.004-.79907.00317Z",
    style: {
      fill: "#ed6f5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.83107,36.01323c.46617-5.44235,1.87765-11.17242,5.92037-15.11866a3.08434,3.08434,0,0,1,1.33911,1.03351,37.85073,37.85073,0,0,1,3.66414,6.72344l-.65848.32155c-1.31293-2.25819-2.47148-5.15361-4.421-6.87306l.58454-.121a27.69079,27.69079,0,0,0-3.921,6.55636,34.28452,34.28452,0,0,0-2.18474,7.51677l-.323-.03895Z",
    style: {
      fill: "#ed6f5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.06606,51.26371a15.61916,15.61916,0,0,1-2.53251,8.196c-2.88529,4.18305-7.51563,5.92809-15.70533,6.08558a29.98181,29.98181,0,0,1-9.29847-1.304c-7.26994-2.21752-11.95067-4.51694-13.53822-11.91917a17.97948,17.97948,0,0,1,1.18436-11.1002c4.27755-9.57566,14.49578-16.10223,24.72662-13.11613a24.96754,24.96754,0,0,1,7.61642,3.55307",
    style: {
      fill: "none",
      stroke: "#ffafa1",
      strokeLinejoin: "round",
      strokeWidth: "1.272314779578551px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.54494,26.45964a25.13775,25.13775,0,0,1,.31323,4.87744,32.10933,32.10933,0,0,1-.688,5.68689,38.42062,38.42062,0,0,1-1.6062,5.34546l-.06347.16785c-.15723.44946-.34742.88171-.52759,1.32739l-.002.0116c-.20557.45349-.39576.88562-.5896,1.34106-.03663.07715-.071.1427-.10767.22-.36865.79493-.78565,1.59388-1.17773,2.38514l-.01709.03283a.505.505,0,0,0,.21118.66468.51172.51172,0,0,0,.24536.06323.505.505,0,0,0,.44067-.25916c.15186-.27209.30567-.55578.45752-.82788.05786,1.16248.04663,2.38489-.009,3.65943A18.33148,18.33148,0,0,1,72.201,53.377a13.65017,13.65017,0,0,1-2.17066,5.59717.98762.98762,0,0,1-.10571.13708A33.36813,33.36813,0,0,1,60.606,61.06633c-.32519,0-.63769-.014-.93334-.0437-5.25855-.5459-12.06983-3.998-11.19312-15.1571A33.02224,33.02224,0,0,1,55.6487,28.18376l.11572.01905a17.02042,17.02042,0,0,1,1.99243.45923,24.87744,24.87744,0,0,1,6.79981,3.0227c-.97632.73047-1.93115,1.47644-2.88819,2.23389a.31152.31152,0,0,0-.07055.42822.32716.32716,0,0,0,.25781.12732.335.335,0,0,0,.18189-.05481c1.08618-.74817,2.17016-1.48462,3.27563-2.20581.2561-.18347.522-.35376.78589-.51221.25415-.17212.5083-.34411.77222-.50268.73169-.47364,1.46167-.93579,2.20312-1.396,1.20191-.72888,2.40161-1.44641,3.62476-2.08862.61279-.32691,1.23291-.62879,1.84741-.896a7.719,7.719,0,0,1,.91138-.337c.02514-.00782.06176-.01368.08691-.02137M69.9131,42.22637a.64684.64684,0,0,0,.519-.2544c.30005-.4497.58838-.90137.844-1.37036.21143-.34546.40161-.70642.58032-1.06921a9.83632,9.83632,0,0,0,.49951-1.08252,20.45235,20.45235,0,0,0,1.6438-6.94385.575.575,0,0,0-.25927-.51807.60851.60851,0,0,0-.33008-.09936.5682.5682,0,0,0-.25806.06177,18.982,18.982,0,0,0-3.91723,2.49218c-.21949.17774-.4292.369-.64112.5719-.22119.18921-.43481.40369-.64844.618a24.8797,24.8797,0,0,0-2.01831,2.36536.58426.58426,0,0,0-.10522.4939.60164.60164,0,0,0,.31494.3966,7.96742,7.96742,0,0,1,3.26929,3.962.58679.58679,0,0,0,.43823.36938l.03467.00574.03393.00086M75.54494,25.1873a1.26808,1.26808,0,0,0-.3291.04334c-.04029.00964-.10791.02685-.13526.03528a8.55524,8.55524,0,0,0-1.02368.37793q-.97632.42424-1.95654.94763c-1.26709.66516-2.51587,1.41382-3.68555,2.12329-.75952.47131-1.49634.93774-2.23486,1.41577-.239.14282-.5022.31958-.76587.49817l-.08032.04871c-.02466-.01917-.05029-.03736-.07642-.05469a26.30135,26.30135,0,0,0-7.14526-3.18237,18.13087,18.13087,0,0,0-2.14087-.49292l-.116-.01917a1.28549,1.28549,0,0,0-.20654-.01684,1.27268,1.27268,0,0,0-.981.46191A34.38228,34.38228,0,0,0,47.2112,45.76592c-1.1023,14.02856,9.15894,16.193,12.33008,16.52221.33545.0337.69214.05042,1.06469.05042a33.13734,33.13734,0,0,0,9.71851-2.01941,1.27562,1.27562,0,0,0,.48242-.29114,1.877,1.877,0,0,0,.24707-.29761,15.00605,15.00605,0,0,0,2.40235-6.14648,19.56255,19.56255,0,0,0,.2395-2.37622c.06177-1.41321.0647-2.64905.00854-3.77478a1.27223,1.27223,0,0,0-.51391-.9596q.12122-.25066.23755-.50073l.03906-.07922.06372-.13049.02124-.04725c.18994-.44628.37622-.86975.57764-1.31408.01757-.03858.0332-.07813.04687-.11829l.12451-.30334c.14063-.33936.2793-.67627.40039-1.02246l.01783-.046.03418-.09021a39.818,39.818,0,0,0,1.6582-5.51929,33.3742,33.3742,0,0,0,.7185-5.9375,26.40314,26.40314,0,0,0-.33178-5.12329,1.27237,1.27237,0,0,0-1.25342-1.05384ZM67.40969,37.1657a21.83463,21.83463,0,0,1,1.44458-1.6427c.19531-.19593.38476-.38611.56689-.54175.01807-.01538.03564-.03137.05273-.04773.21778-.2085.39625-.368.562-.5022a16.34307,16.34307,0,0,1,2.58447-1.765,19.14448,19.14448,0,0,1-1.43262,5.27978,8.92111,8.92111,0,0,1-.45141.98267c-.21216.42883-.37867.73608-.54541,1.00867-.01123.01818-.02173.03662-.032.05529q-.06334.11628-.12915.23047a9.39552,9.39552,0,0,0-2.62011-3.05749Z",
    style: {
      fill: "#ed6f5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.60671,34.043C63.1509,32.89412,76.0498,22.69223,76.7088,25.4062c1.74465,7.93583-1.10848,16.03729-4.95913,22.89891l-.63808-.36012c.43774-.86889.8938-1.728,1.31592-2.60241,2.79185-6.01957,4.45089-13.00771,3.10011-19.58326l.49022.43152a1.98124,1.98124,0,0,0-.74463.12842c-4.83425,1.95535-9.0858,5.18335-13.398,8.08261l-.26847-.35885Z",
    style: {
      fill: "#ed6f5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.91028,30.89022a9.41006,9.41006,0,0,1,1.34827-4.63657,13.956,13.956,0,0,1,1.4167,2.6686Z",
    style: {
      fill: "none",
      stroke: "#ed6f5f",
      strokeMiterlimit: 10,
      strokeWidth: "1.272314779578551px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.81001,
    cy: 48.61928,
    rx: 3.06232,
    ry: 1.67742,
    transform: "translate(-9.11156 85.17983) rotate(-74.14929)",
    style: {
      fill: "#ed6f5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.91725,27.9981a31.42462,31.42462,0,0,0-2.49878,4.27111c-.054.11-.10961.23157-.17675.3512q-.08094.165-.16138.33008c-.32471.67151-.65112,1.35461-.97,2.06274-2.11279,4.59632-4.22632,9.7749-7.27319,13.83679-1.82837,2.43494-3.46119,3.34754-4.88086,3.34754a4.89571,4.89571,0,0,1-3.67383-2.21411,17.49485,17.49485,0,0,1,1.45019-8.58033,24.81743,24.81743,0,0,1,2.57569-4.44873l.0039-.02307c.21729-.309.44043-.58117.677-.863l.00586-.03479c.2539-.3147.502-.59473.77734-.894a21.68745,21.68745,0,0,1,9.22046-6.18213c.1521-.0581.30249-.10461.45288-.15124l.01147.00195a2.96525,2.96525,0,0,1,.46241-.13769,17.44465,17.44465,0,0,1,3.99755-.67224m.00025-1.27234c-.02027,0-.04053.00048-.061.00146a18.70858,18.70858,0,0,0-4.24658.70825,4.168,4.168,0,0,0-.48706.14c-.01807.00476-.03613.00989-.05371.01538-.17041.05273-.33594.10486-.50342.16772a22.95977,22.95977,0,0,0-9.7417,6.53272c-.32641.35461-.575.64075-.81909.94324a1.288,1.288,0,0,0-.10864.15747c-.19654.23706-.41333.50683-.62476.80737a1.30022,1.30022,0,0,0-.07763.12537,26.122,26.122,0,0,0-2.623,4.55993,18.71977,18.71977,0,0,0-1.55591,9.2074,1.27186,1.27186,0,0,0,.26758.6781c1.40942,1.79138,2.98193,2.69971,4.67383,2.69971,1.99267,0,3.977-1.29737,5.89819-3.856,2.66211-3.54871,4.58032-7.803,6.4353-11.91724.32788-.727.65235-1.44641.97657-2.1521.31811-.70629.63964-1.379.95947-2.04028l.14477-.296c.0564-.10327.10718-.20691.15479-.30591l.0354-.07275a29.885,29.885,0,0,1,2.38672-4.08508,1.2723,1.2723,0,0,0-1.03-2.0188Z",
    style: {
      fill: "#ed6f5f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.10547,
    cy: 45.53517,
    rx: 2.56774,
    ry: 1.40651,
    transform: "translate(-14.34547 73.3628) rotate(-78.0242)",
    style: {
      fill: "#ed6f5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.45791,54.78292c.14494.77652.29254,1.14089.85085,1.24747a1.71989,1.71989,0,0,0,1.52-.59671,5.076,5.076,0,0,0,.84815-1.46937,5.88365,5.88365,0,0,0,.27375,1.91676,1.99272,1.99272,0,0,0,1.34436,1.29385,2.94757,2.94757,0,0,0,2.29025-.89447",
    style: {
      fill: "none",
      stroke: "#ed6f5f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.272314779578551px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4945,53.18305a.75.75,0,0,0,.77549.63082",
    style: {
      fill: "none",
      stroke: "#ed6f5f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.272314779578551px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.77767,42.91931C82.977,59.98165,67.98773,69.29522,50.92539,67.49453S21.18878,53.46078,22.98946,36.39844a31.06567,31.06567,0,1,1,61.78821,6.52087Z",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.272314779578551px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.64178,70.43111A51.95112,51.95112,0,0,1,40.2857,68.95324c-1.664-.49187-2.50182-1.73778-1.93386-2.6615h0c.56793-.92364,2.19995-1.2484,3.69407-.81663,6.7558,2.09764,13.17881,1.75992,20.09854,1.19885,1.6207-.25712,3.14163.26931,3.36817,1.29173h0C65.73916,68.98811,64.4426,70.15784,62.64178,70.43111Z",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeMiterlimit: 10,
      strokeWidth: "1.272314779578551px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.07622,70.906a4.37973,4.37973,0,0,1,.57255.06362,4.63762,4.63762,0,0,1-1.64129,9.12886,3.77569,3.77569,0,0,1-.528-.13359",
    style: {
      fill: "none",
      stroke: "#efc457",
      strokeMiterlimit: 10,
      strokeWidth: "1.272314779578551px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.73032,
    cy: 75.33529,
    rx: 4.63894,
    ry: 4.63467,
    transform: "translate(-38.15472 105.04367) rotate(-79.80694)",
    style: {
      fill: "none",
      stroke: "#efc457",
      strokeMiterlimit: 10,
      strokeWidth: "1.272314779578551px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.51359,77.23219l.48309.087.70683-3.93283-.48309-.087.07374-.40783,3.70755.66666L45.78,74.7893l-.70072-.1256.14187-.78921-1.5713-.28273-.30714,1.70758,1.0338.18612.08086-.449.46986.08441-.241,1.33993-.46987-.08441.08085-.44851-1.0338-.18611L42.94912,77.49l.64632.11645-.07373.40833-2.08185-.37426Z",
    style: {
      fill: "#6e6bb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.54531,91.60777,69.004,91.42962c-9.14794-6.87685-4.69484-17.01084-2.691-20.59241,1.7876,2.29015,4.84752,5.93536,7.20131,7.34761C77.05773,80.316,84.54531,86.63938,84.54531,91.60777Z",
    style: {
      fill: "none",
      stroke: "#ed6f5f",
      strokeMiterlimit: 10,
      strokeWidth: "1.272314779578551px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.99351,23.40044A25.58367,25.58367,0,0,1,37.53929,18.118",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.272314779578551px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.10733,40.23631A29.56963,29.56963,0,0,1,29.555,27.17207",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.272314779578551px"
    }
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPc04);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PC04.7317e1adc607fb6fc2167220f05cd54b.svg";